import Barcode from "components/Commons/BarCode"
import { forwardRef } from "react"

interface TagPrintBodyProps {
  data: any
}

const TagPrintBody = forwardRef<HTMLDivElement, TagPrintBodyProps>(({ data }, ref) => {
  return (
    <div ref={ref}>
      <div className="tag-container">
        {/* Header */}
        <div className="tag-header">
          <div className="header-text">
            <p></p>
          </div>
        </div>

        {/* Service row */}
        <div className="tag-service-row">
          <div className="service-cell">
            <div className="service-label">SERVICIO</div>
            <div className="service-value">{data?.deliveryType}</div>
          </div>
          <div className="service-cell">
            <div className="service-label">REMITENTE</div>
            <div className="service-value">{data?.from}</div>
          </div>
          <div className="service-cell">
            <div className="service-label">EMPRESA</div>
            <div className="service-value">ENTEL</div>
          </div>
        </div>

        {/* Barcode */}
        <div className="tag-barcode">
          <div className="barcode-lines">
            <Barcode showSvg value={data?.numberGuide} height={50} displayValue={false} />
          </div>
        </div>

        {/* Order info */}
        <div className="tag-order-info">
          <div className="order-number">{data?.numberGuide}</div>
          <div className="tracking-code">CÓDIGO DE SEGUIMIENTO</div>
        </div>

        {/* Destinatario */}
        <div className="tag-field">
          <div className="field-label">DESTINATARIO</div>
          <div className="field-value">{data?.to}</div>
        </div>

        {/* Dirección */}
        <div className="tag-field">
          <div className="field-label">DIRECCIÓN</div>
          <div className="field-value">{data?.address}</div>
        </div>

        {/* Bottom row */}
        <div className="tag-bottom-row">
          <div className="bottom-field">
            <div className="field-label">FONO</div>
            <div className="field-value">{data?.phone}</div>
          </div>
          <div className="bottom-field">
            <div className="field-label">FECHA DE COMPROMISO</div>
            <div className="field-value">{data?.date}</div>
          </div>
        </div>
      </div>

      <style>{`
        .tag-container {
          width: 120mm;
          height: auto;
          font-family: Arial, sans-serif;
          font-size: 12px;
          border: 2px solid black;
          background: white;
          display: flex;
          flex-direction: column;
        }
        
        .tag-header {
          padding: 8px;
          text-align: center;
          border-bottom: 1px solid black;
          flex-shrink: 0;
        }
        
        .header-text {
          font-weight: bold;
          font-size: 14px;
        }
        
        .tag-service-row {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          min-height: 40px;
        }
        
        .service-cell {
          padding: 6px;
          border-right: 1px solid black;
          border-bottom: 1px solid black;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        
        .service-cell:last-child {
          border-right: none;
        }
        
        .service-label {
          font-weight: bold;
          font-size: 10px;
          margin-bottom: 4px;
          line-height: 1.2;
        }
        
        .service-value {
          font-size: 10px;
          line-height: 1.2;
          word-break: break-word;
        }
        
        .tag-barcode {
          width: 100%;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 8px;
          position: relative;
        }
        
        .barcode-lines {
          width: 60%;
          display: flex;
          justify-content: center;
          align-items: end;
          height: 35px;
          gap: 1px;
          margin-top: 35px;
        }
        
        .barcode-line {
          background: black;
          width: 3px;
          height: 100%;
        }
        
        .barcode-line.thin {
          width: 2px;
          height: 80%;
        }
        
        .tag-order-info {
          margin-top: -20px;
          padding: 8px;
          text-align: center;
          border-bottom: 1px solid black;
          flex-shrink: 0;
        }
        
        .order-number {
          font-weight: bold;
          font-size: 12px;
          line-height: 1.3;
        }
        
        .tracking-code {
          font-size: 10px;
          margin-top: 4px;
          line-height: 1.3;
        }
        
        .tag-field {
          padding: 8px;
          border-bottom: 1px solid black;
          min-height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }
        
        .field-label {
          font-weight: bold;
          font-size: 10px;
          margin-bottom: 4px;
          flex-shrink: 0;
          line-height: 1.2;
        }
        
        .field-value {
          font-size: 10px;
          line-height: 1.3;
          word-wrap: break-word;
          overflow-wrap: break-word;
          word-break: break-word;
          flex-grow: 1;
        }
        
        .tag-bottom-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          min-height: 50px;
        }
        
        .bottom-field {
          padding: 8px;
          border-right: 1px solid black;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        
        .bottom-field:last-child {
          border-right: none;
        }
        
        .bottom-field .field-label {
          font-weight: bold;
          font-size: 10px;
          margin-bottom: 4px;
          flex-shrink: 0;
          line-height: 1.2;
        }
        
        .bottom-field .field-value {
          font-size: 10px;
          line-height: 1.3;
          word-break: break-word;
          flex-grow: 1;
        }
        
        @media print {
          .tag-container {
            margin: 0;
            box-shadow: none;
          }
        }
      `}</style>
    </div>
  )
})

TagPrintBody.displayName = "TagPrintBody"

export default TagPrintBody
